/**
 * The six teams, with the original's stats read off its team screen
 * (design.md A4), renamed to fictional teams with colour nods (B4, B18).
 */
export interface TeamSpec {
  id: string;
  name: string;
  tier: number;
  zeroTo100: number; // seconds, as quoted in the original
  topSpeedMph: number;
  primary: number;
  secondary: number;
}

export const TEAMS: readonly TeamSpec[] = [
  { id: 'marlin', name: 'MARLIN', tier: 1, zeroTo100: 6.5, topSpeedMph: 218, primary: 0xf2f2f2, secondary: 0xd01020 },
  { id: 'wolfe', name: 'WOLFE', tier: 2, zeroTo100: 6.9, topSpeedMph: 217, primary: 0x1c3fa8, secondary: 0xf5d000 },
  { id: 'bramley', name: 'BRAMLEY', tier: 3, zeroTo100: 7.1, topSpeedMph: 212, primary: 0xe8e8f0, secondary: 0x3050c8 },
  { id: 'lotos', name: 'LOTOS', tier: 4, zeroTo100: 7.7, topSpeedMph: 207, primary: 0xf5d21a, secondary: 0x1a5fd0 },
  { id: 'bennet', name: 'BENNET', tier: 5, zeroTo100: 7.9, topSpeedMph: 196, primary: 0x2fbf4a, secondary: 0xf2f2f2 },
  { id: 'ferro', name: 'FERRO', tier: 6, zeroTo100: 8.2, topSpeedMph: 185, primary: 0xd81818, secondary: 0xf5d000 },
];

export const DEFAULT_TEAM = 'bennet'; // the original's second-slowest starting car

export function teamById(id: string): TeamSpec {
  return TEAMS.find((t) => t.id === id) ?? TEAMS[4];
}
